<template>
  <div>
    <user-detail-title
      first-bread="瑞普乐园"
      second-bread="瑞普乐园修改"
      first-url="/user/land"
      title-name="瑞普乐园修改"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="年份">
          <el-input v-model="Clist.year" :placeholder="LookData.year" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :rows="8" v-model="Clist.description" :placeholder="LookData.description"
                    style="width: 400px;"

          ></el-input>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "LandChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
        Clist: {
          'id':this.$route.params.id,
          'year':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.photoUrl=file.data;
      },
      handleChange(){
        if ( this.Clist.name || this.Clist.photoUrl || this.Clist.description){
          this.$axios.post('/api/fairyland/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id':this.$route.params.id,
                'year':null,
                'photoUrl':null,
                'description':null,
              }//表示Add添加的数据,
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一项上传')
        }
      },
      GetLookData(id){
        this.$axios.get('/api/fairyland/getById/'+id).then(res=>{
          this.LookData=res.data.data
        })
      }
    },
  }
</script>

<style scoped>

</style>